import { useFormContext } from "react-hook-form";
import { AdditionalInfoSummary } from "../../../../../shared/additional-info/AdditionalInfoSummary";
import { type AdminBondRequestFormData, fp } from "../../schema";

export const BondAdditionalInfoSummary = () => {
	const { getValues } = useFormContext<AdminBondRequestFormData>();
	const additionalInfo = getValues().quote.additionalInfo;

	return (
		<AdditionalInfoSummary
			comment={additionalInfo?.comment}
			attachments={additionalInfo?.attachments}
			commentFieldPath={fp("quote.additionalInfo.comment")}
			attachmentsFieldPath={fp("quote.additionalInfo.attachments")}
			header="Bond Info"
			commentLabel="Comment"
			section="bondAdditionalInfo"
		/>
	);
};
